// Đặt mật khẩu mới với token từ URL. Khung chung components/auth/AuthStage.tsx.

import { useState } from 'react'
import { Link, useSearchParams, useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { ApiError, post } from '@/lib/api'
import { AuthStage, AuthTitle } from '@/components/auth/AuthStage'
import { AuthError, AuthPassword, AuthSubmit, finePointer } from '@/components/auth/AuthFields'

const MIN = 10

export default function ResetPasswordPage() {
  const [params] = useSearchParams()
  const token = params.get('token') ?? ''
  const nav = useNavigate()
  const [pw, setPw] = useState('')
  const [pw2, setPw2] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const mismatch = pw2.length > 0 && pw !== pw2

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (pw.length < MIN || pw !== pw2) return
    setBusy(true)
    setError(null)
    try {
      await post('/auth/password/reset', { token, newPassword: pw })
      toast.success('Đã đặt lại mật khẩu — đăng nhập lại nhé')
      nav('/login', { replace: true })
    } catch (err) {
      setError(err instanceof ApiError && err.code === 'validation.invalid' ? 'Link không hợp lệ hoặc đã hết hạn.' : (err as Error).message || 'Không đặt được mật khẩu, thử lại sau')
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthStage homeLink="/login">
      {!token ? (
        <>
          <AuthTitle sub="Link thiếu mã đặt lại hoặc đã hết hạn.">Link không hợp lệ</AuthTitle>
          <Link to="/forgot-password" className="lg-btn2">Gửi lại link</Link>
        </>
      ) : (
        <form onSubmit={onSubmit} noValidate>
          <AuthTitle>Đặt mật khẩu mới</AuthTitle>
          <AuthPassword id="reset-pw" label="Mật khẩu mới" note={`Tối thiểu ${MIN} ký tự`} value={pw} onChange={setPw} autoFocus={finePointer()} />
          <AuthPassword id="reset-pw2" label="Nhập lại" value={pw2} onChange={setPw2} invalid={mismatch}>
            {mismatch && <p className="lg-hint">Hai mật khẩu chưa khớp</p>}
          </AuthPassword>
          {error && <AuthError>{error}</AuthError>}
          <AuthSubmit busy={busy} busyLabel="Đang đặt…" disabled={pw.length < MIN || pw !== pw2}>Đặt mật khẩu</AuthSubmit>
        </form>
      )}
    </AuthStage>
  )
}
